module.exports = __webpack_public_path__ + "static/media/ncb shot 04-mobile.fddd107e.webp";